import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div
    className='app__aboutus app__bg flex__center section__padding'
    id='about'
  >
    <div className='app__aboutus-overlay flex__center'>
      <img src={images.G} alt='About Us Overlay' />
    </div>

    <div className='app__aboutus-content flex__center'>
      <div className='app__aboutus-content_about'>
        <h1 className='headtext__cormorant'>Who We Are</h1>
        <img src={images.spoon} alt='About Spoon' className='spoon__img' />
        <p className='p__opensans'>
          We are passionate about delivering an exceptional dining experience.
          Our vision is to blend tradition with innovation, bringing fresh, bold
          flavors to every plate. From concept to creation, we focus on quality,
          creativity, and passion in every detail.
        </p>
        <button type='button' className='custom__button'>
          Discover Our Story
        </button>
      </div>

      <div className='app__aboutus-content_knife flex__center'>
        <img src={images.knife} alt='About Knife' />
      </div>

      <div className='app__aboutus-content_history'>
        <h1 className='headtext__cormorant'>Our Legacy</h1>
        <img src={images.spoon} alt='Legacy Spoon' className='spoon__img' />
        <p className='p__opensans'>
          Our history is rooted in a rich tradition of culinary excellence. From
          humble beginnings, we have grown into a renowned dining destination,
          committed to delivering unforgettable moments through food and
          service. Join us and be part of our journey.
        </p>
        <button type='button' className='custom__button'>
          Learn More
        </button>
      </div>
    </div>
  </div>
);

export default AboutUs;
